<!-- BURGER -->
<div id="mm-burger" (click)="onToggleMenu()" [class.active]="menuActive">
  <span></span>
  <span></span>
</div>

<!-- MENU ITSELF -->
<div class="mm-content" [class.visible]="menuActive" [class.invisible]="!menuActive">
  <!-- LOGO -->
  <div class="mm-content__logo" [class.visible]="menuActive" [class.invisible]="!menuActive">
    <svg viewBox="0 0 512 256">
      <use [attr.xlink:href]="'assets/images/logo.svg#svg1'"></use>
    </svg>
  </div>
  <!-- TITLE -->
  <div class="mm-content__title">menu</div>
  <!-- MENU ITEMS -->
  <div class="mm-content__items">

    <div class="mm-content__items__item"
         [class.visible]="menuActive"
         [class.invisible]="!menuActive"
         routerLink="/intramonth"
         routerLinkActive="active"
         (click)="onToggleMenu()">
      intramonth
      <svg viewBox="0 0 24 24">
        <use [attr.xlink:href]="'assets/icons/arrow_right.svg#svg1'"></use>
      </svg>
    </div>

  </div>

  <!-- SETTINGS -->
  <!--
  <div class="mm-content__settings"
       [class.visible]="menuActive"
       [class.invisible]="!menuActive"
       routerLink="/settings"
       routerLinkActive="active"
       (click)="onToggleMenu()"
       matTooltip="settings">
    <mat-icon>settings</mat-icon>
  </div>
  -->

</div>

